import {
	ContactListItem,
	ContactSource,
	listGlobalContacts
} from "client/Api/Email/contacts";
import { createRemoteDataSource, LazyLoadCursorKind } from "client/Hooks";
import { hasImplicitDependencyOn } from "client/Misc/reactUtils";
import { ReactElement, useEffect, useState } from "react";
import { Guid } from "client_legacy/ndaw/guid";
import { addressBookLiveTilePageSize } from "../AddressBookLiveTileContent";
import { GenericContactsTab } from "./GenericContactsTab";
import { userConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";

const useGlobalContactsDataSource = createRemoteDataSource<ContactListItem>()
	.setConfiguration({
		hasSearch: true,
		lazyLoadCursor: LazyLoadCursorKind.SkipToken
	})
	.getHook({
		performRequest: async (options) => {
			const { exchange } = userConfiguration();
			if (!exchange.isConfigured || !exchange.isEnabled) {
				throw new Error("Exchange is not available");
			}

			return await listGlobalContacts(
				options.searchTerm,
				options.amount,
				options.skipToken,
				options.signal
			);
		}
	});

export type GlobalContactsTabProps = {
	searchTerm: VersionedValue<string>;
	onSearchTermChange(newValue: string, version: Guid): void;
	onListItemClick(): void;
};

export const GlobalContactsTab = (props: GlobalContactsTabProps): ReactElement => {
	const {
		searchTerm,
		onSearchTermChange,
		onListItemClick
	} = props;

	const [desiredAmountOfItems, setDesiredAmountOfItems] = useState<number>(addressBookLiveTilePageSize);

	const {
		currentItems,
		hasMoreOnServer,
		getLoadingState,
		reload
	} = useGlobalContactsDataSource({
		searchTerm: searchTerm.value,
		desiredAmountOfItems
	});

	useEffect(
		(): void => {
			hasImplicitDependencyOn(searchTerm);
			setDesiredAmountOfItems(addressBookLiveTilePageSize);
		},
		[searchTerm]
	);

	return (
		<GenericContactsTab
			contacts={currentItems}
			loadingState={getLoadingState()}
			searchTerm={searchTerm}
			onSearchTermChange={onSearchTermChange}
			source={ContactSource.Gal}
			hasMore={hasMoreOnServer}
			onLoadMore={() => setDesiredAmountOfItems(a => a + addressBookLiveTilePageSize)}
			onRetry={reload}
			onListItemClick={onListItemClick}
		/>
	);
};
GlobalContactsTab.displayName = "GlobalContactsTab";